export default __webpack_public_path__ + "c231412e799533478fb9d192ad594bcf.vtt";